export default "__VITE_ASSET__BuDGhNgg__"